module.exports = __webpack_public_path__ + "static/media/sss-auto-street-selected.c79a8b5e.svg";